import { createRootRoute, Outlet } from "@tanstack/react-router";

import { AppBackground } from "../components/app-background.js";

/**
 * The root layout.
 *
 * Deliberately empty of AUTH policy — authentication and the onboarding redirect live in the
 * pathless `_authenticated` layout, so a route's file path says whether it is guarded.
 *
 * What does belong here is chrome. `AppBackground` is mounted once, at the root, because it owns a
 * WebGL context: browsers cap how many can be live, and mounting it per route would rebuild the
 * context on every navigation and restart the animation from a standstill. At the root the waves
 * keep rolling as you move between pages.
 *
 * It sits OUTSIDE the guarded subtree on purpose, so it renders on sign-in and on the loading state
 * as well as on the app proper — the background is chrome, not content.
 */
export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <>
      <AppBackground />
      <div className="app-content">
        <Outlet />
      </div>
    </>
  );
}
